(function () {
  const init = () => {
    document.querySelectorAll('.cartridge-comparison-table-section').forEach((section) => {
      if (section.dataset.comparisonReady === 'true') return;
      section.dataset.comparisonReady = 'true';

      const toggle = section.querySelector('[data-comparison-show-more]');
      const rows = Array.from(section.querySelectorAll('[data-comparison-row-hidden]'));

      if (!(toggle instanceof HTMLButtonElement) || !rows.length) return;

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;

        rows.forEach((row) => {
          row.hidden = !nextExpanded;
        });

        toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        toggle.textContent = nextExpanded
          ? toggle.dataset.expandedLabel || 'Show less'
          : toggle.dataset.collapsedLabel || 'Show more';
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
